export default "__VITE_ASSET__DCMmm64P__"